var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0005 27.5C84.173 27.5 83.358 27.545 82.5505 27.6225C76.853 19.975 67.7705 15 57.5005 15C43.218 15 31.2005 24.5925 27.4705 37.6775C17.623 38.9225 10.0005 47.3125 10.0005 57.5C10.0005 68.545 18.9555 77.5 30.0005 77.5C34.5455 77.5 80.268 77.5 85.0005 77.5C98.808 77.5 110 66.3075 110 52.5C110 38.6925 98.808 27.5 85.0005 27.5Z",
    fill: "url(#paint0_linear_184103_183587)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87C27 87 40.7132 87 49.5 87C58.2868 87 72 87 72 87",
    stroke: "url(#paint1_linear_184103_183587)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81 87H90",
    stroke: "url(#paint2_linear_184103_183587)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 99H82.5",
    stroke: "url(#paint3_linear_184103_183587)",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_184103_183587",
    x1: 53.283,
    y1: 15.1975,
    x2: 64.0455,
    y2: 78.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.482325,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_184103_183587",
    x1: 49.5,
    y1: 84.5,
    x2: 49.5,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_184103_183587",
    x1: 85.5,
    y1: 84.5,
    x2: 85.5,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_184103_183587",
    x1: 63,
    y1: 96.5,
    x2: 63,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CB9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.a1e348f843694b00ef30239481872f5d.svg";
export { ForwardRef as ReactComponent };